import { useEffect, useState } from "react";

const getTimeLeft = (targetISO) => {
  const diff = +new Date(targetISO) - +new Date();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, done: true };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    done: false,
  };
};

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="font-mono font-bold text-2xl sm:text-4xl lg:text-5xl text-acid tabular-nums leading-none">
      {String(value).padStart(2, "0")}
    </div>
    <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-2">
      {label}
    </div>
  </div>
);

export const CountdownTimer = ({ targetISO, compact = false }) => {
  const [time, setTime] = useState(() => getTimeLeft(targetISO));

  useEffect(() => {
    const id = setInterval(() => setTime(getTimeLeft(targetISO)), 1000);
    return () => clearInterval(id);
  }, [targetISO]);

  if (compact) {
    return (
      <div
        className="flex items-center gap-2 font-mono text-xs sm:text-sm text-acid tabular-nums"
        data-testid="countdown-timer-compact"
      >
        <span>{String(time.days).padStart(2, "0")}d</span>
        <span className="text-zinc-600">:</span>
        <span>{String(time.hours).padStart(2, "0")}h</span>
        <span className="text-zinc-600">:</span>
        <span>{String(time.minutes).padStart(2, "0")}m</span>
        <span className="text-zinc-600">:</span>
        <span>{String(time.seconds).padStart(2, "0")}s</span>
      </div>
    );
  }

  return (
    <div
      className="flex items-center gap-4 sm:gap-8"
      data-testid="countdown-timer"
    >
      <Unit value={time.days} label="Days" />
      <span className="text-acid text-2xl sm:text-4xl font-mono -mt-4">:</span>
      <Unit value={time.hours} label="Hrs" />
      <span className="text-acid text-2xl sm:text-4xl font-mono -mt-4">:</span>
      <Unit value={time.minutes} label="Min" />
      <span className="text-acid text-2xl sm:text-4xl font-mono -mt-4">:</span>
      <Unit value={time.seconds} label="Sec" />
    </div>
  );
};
